import { useAuth, useClerk } from '@clerk/clerk-react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useEffect } from 'react';

import { ApolloWrapper } from '~/components/apollo-wrapper.tsx';
import { useAppConfig } from '~/utils/use-app-config.ts';

export const Route = createFileRoute('/$pathLocale/_layout/_auth')({
  component: RouteComponent,
});

function RouteComponent() {
  const appConfig = useAppConfig();
  const auth = useAuth();
  const clerk = useClerk();

  useEffect(() => {
    if (!auth.isSignedIn) {
      clerk.redirectToSignIn();
    }
  }, [auth, clerk]);

  if (!auth.isSignedIn) {
    return null;
  }

  return (
    <ApolloWrapper endpoint={appConfig.graphqlEndpoint}>
      <Outlet />
    </ApolloWrapper>
  );
}
